module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/queen.19cc8e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/queen.jpg
// module id = uXCA
// module chunks = 0